import { Box, List, ListItem, Typography } from '@mui/material';
import { Dialog } from '../../../../../../components/general/dialog/dialog';
import DateTimeFormat from '../../../../../../components/dateTimeFormat';
import {
    EmailSendingRecord,
} from '../../../../../../../services/emailSending.service';

type Props = {
    emailSending?: EmailSendingRecord;
    onClose: () => void;
};

export const DetailEmailSending = ({ emailSending, onClose }: Props) => {
    return (
        <Dialog
            title="DETALLE ENVIO EMAIL"
            open={Boolean(emailSending)}
            onClose={onClose}
            maxWidth="md"
        >
            <Box display="flex" flexDirection="column" gap={1}>
                <Box>
                    <Typography variant="subtitle2" color="primary.main">
                        Fecha de envío
                    </Typography>
                    <Typography>
                        {emailSending ? (
                            <DateTimeFormat dateAt={emailSending.created_at} />
                        ) : (
                            ''
                        )}
                    </Typography>
                </Box>

                <Box>
                    <Typography variant="subtitle2" color="primary.main">
                        Destinatario
                    </Typography>
                    <Typography>{emailSending?.recipient}</Typography>
                </Box>

                <Box>
                    <Typography variant="subtitle2" color="primary.main">
                        Asunto
                    </Typography>
                    <Typography>{emailSending?.subject}</Typography>
                </Box>

                <Box>
                    <Typography variant="subtitle2" color="primary.main">
                        Cuerpo
                    </Typography>
                    <div
                        dangerouslySetInnerHTML={{
                            __html: emailSending?.body || '',
                        }}
                    />
                </Box>

                <Box>
                    <Typography variant="subtitle2" color="primary.main">
                        Archivos adjuntos
                    </Typography>
                    {emailSending?.attachments?.length ? (
                        <List dense>
                            {emailSending.attachments.map((name) => (
                                <ListItem key={name} sx={{ pl: 0 }}>
                                    <Typography>{name}</Typography>
                                </ListItem>
                            ))}
                        </List>
                    ) : (
                        <Typography>Sin adjuntos</Typography>
                    )}
                </Box>
            </Box>
        </Dialog>
    );
};